import { render, staticRenderFns } from "./motion.vue?vue&type=template&id=9629f52a&"
import script from "./motion.vue?vue&type=script&lang=js&"
export * from "./motion.vue?vue&type=script&lang=js&"
import style0 from "./motion.vue?vue&type=style&index=0&id=9629f52a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports